
import Vue from 'vue';
import cinput from './../CInput.vue';
import cbutton from './../CButton.vue';
import cdropdown from './../CDropdown.vue';
import cdatepicker from './../CDatepicker.vue';
import cmapautocomplete from './../CMapAutocomplete.vue';
import ctable from './../CTable.vue';
import { get } from 'lodash';

export default Vue.extend({
  components: {
    cbutton,
    cinput,
    cpassword: cinput,
    cdropdown,
    cdatepicker,
    cmapautocomplete,
    ctable,
    cfileupload: cbutton
  },
  props: {
    input: { type: Object, default: () => {} },
    group: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    rowDisabled: { type: Boolean, default: false }
  },
  computed: {
    inputConfig: function (): any {
      return this.input.config;
    },
    items: function(): any {
      const itemVariable: any[] = this.getVariable(this.input.items) || [];
      let itemsArray = itemVariable.map( currentItem => this.retrieveItemValue(currentItem));
      itemsArray = itemsArray.map(item => {
        return {...item, variable: `${this.input.variable}.${item.variable}`, disabled: this.input.disabled };
      });
      return [ itemsArray ];
    }
  },
  methods: {
    retrieveItemValue: function(item: any): any {
      let obj: any = { row: 1 };
      Object.keys(this.inputConfig).forEach((key: string) => {
        if(this.inputConfig[key].startsWith('__item.')) {
          obj[key] = get(item, this.inputConfig[key].split('__item.')[1]);
        } else {
          obj[key] = this.inputConfig[key];
        }
      });
      return obj;
    }
  }
});
